import SwipeListener from 'swipe-listener';
const rootSelector = 'c-hero_slider';
const hero_slider = document.getElementById(`${rootSelector}__background`);

function init() {

  if (!hero_slider) {
    return;
  }

  const background = document.getElementById(`${rootSelector}__background`);
  const slides = document.getElementById(`${rootSelector}`);
  const slide_container = document.getElementById(`${rootSelector}__slides`);
  const slide_counter = document.getElementById(`${rootSelector}__counter`);
  const slide_controls = document.getElementById(`${rootSelector}__controls`);
  const slide_foreground = document.getElementById(`${rootSelector}__foreground`);
  const slide_list = slide_container.getElementsByTagName("li");
  const slide_length = slide_list.length;
  const slide_up = document.getElementById(`${rootSelector}__up`);
  const slide_down = document.getElementById(`${rootSelector}__down`);
  const navigation = document.getElementsByClassName(`${rootSelector}__navigator`);
  const transitionEvent = whichTransitionEvent();
  const is_touch_device = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/);
  const is_touch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0) || (navigator.maxTouchPoints));
  const listener = SwipeListener(slides);
  const disableBodyScroll = bodyScrollLock.disableBodyScroll;
  const enableBodyScroll = bodyScrollLock.enableBodyScroll;
  const footer_scroll = document.getElementById("c-footer__scroll");
  const footer_bottom = document.getElementById("c-footer__bottom");

  let is_animating = false;
  let current_slide_number = 0;
  let last_transition = 0;
  let previous_time = new Date().getTime();

  let animation_last_transition = 0;
  let animation_previous_time = new Date().getTime();

  zenscroll.setup(1000);

  initListeners();
  init_slider();

  if(is_touch_device){

    const targetElement = document.querySelector(".c-hero_slider__container");
    disableBodyScroll(targetElement);

  }

  function initListeners() {
    for (let i = 0; i < navigation.length; i++) {
      navigation[i].addEventListener('click', function(event) {
        const navigation_id = event.currentTarget.id;
        const slide_number = navigation_id.replace("c", "") - 1;
        let slide = document.getElementById("s" + (slide_number + 1));
        zenscroll.to(slide);
        is_clear(slide_number + 1);
        animate_meta(slide_number);
      });
    }

    slide_up.addEventListener('click', function(event) {
      toggle_slide_direction(current_slide_number, 0);
    });

    slide_down.addEventListener('click', function(event) {
      toggle_slide_direction(current_slide_number, 1);
    });

    footer_scroll.addEventListener('click', function(event) {
      toggle_slide_direction(current_slide_number, 1);
    });

    const listener = SwipeListener(slides);
    slides.addEventListener('swipe', function (e) {
      var direction = e.detail.directions;
      if (direction.top) {
        toggle_slide_direction(current_slide_number, 1);
      } else if (direction.bottom) {
        toggle_slide_direction(current_slide_number, 0);
      }
    });

    document.addEventListener('wheel', detectScrollDirection);
    document.addEventListener('mousewheel', detectScrollDirection);
    document.addEventListener('DOMMouseScroll', detectScrollDirection);

    window.addEventListener('resize', resize_slider);

  }

  function is_clear(slide_number){
    if (slide_number % 2) {
      background.classList.add("clear");
    } else {
      background.classList.remove("clear");
    }
  }

  function init_slider() {
    is_clear(1);
    slide_list[0].className = 'active';
    navigation[0].classList.add('active');
    resize_slider();
  }

  function animate_meta(slide_number) {

    let animation_current_time = new Date().getTime();
    let animation_timeDiff = animation_current_time - animation_previous_time;
    let animation_transitionTimeDiff = animation_current_time - animation_last_transition;
    animation_previous_time = animation_current_time;
    // If scroll event finished
    if((animation_timeDiff > 500 && animation_transitionTimeDiff > 500) || !is_animating){

      is_animating = true;
      let counter = slide_number + 1;
      navigation[current_slide_number].classList.remove('active');
      slide_list[current_slide_number].className = 'was-active';
      slide_counter.innerHTML = `${counter} of ${slide_length}`;
      navigation[slide_number].classList.add('active');
      slide_list[slide_number].className = 'active';
      show_footer(slide_number);
      slide_list[slide_number].addEventListener(transitionEvent, transitionEndCallback);
      function transitionEndCallback(e) {
        slide_list[current_slide_number].className = 'reset';
        slide_list[slide_number].addEventListener(transitionEvent, transitionResetEndCallback);
        function transitionResetEndCallback(e) {
          is_animating = false;
          current_slide_number = slide_number;
          animation_last_transition = new Date().getTime();
          slide_list[slide_number].removeEventListener(transitionEvent, transitionEndCallback);
          slide_list[slide_number].removeEventListener(transitionEvent, transitionResetEndCallback);
        }
      }

    }
  }

  function get_tallest_slide() {
    let tallest_slide = 0;
    for (let i = 0; i < slide_length - 1; i++) {
      tallest_slide = (slide_list[i].clientHeight > tallest_slide) ? slide_list[i].clientHeight : tallest_slide;
    }
    return tallest_slide;
  }

  function show_footer(slide_number) {
    if(slide_number == slide_length - 1) {
      footer_scroll.classList.remove('active');
      footer_bottom.classList.add('active');
    } else {
      footer_scroll.classList.add('active');
      footer_bottom.classList.remove('active');
    }
  }

  function resize_slider() {
    let header_height = document.getElementById("c-header").clientHeight;
    let footer_height = document.getElementById("c-footer-sticky").clientHeight;
    slide_foreground.style.paddingTop = (header_height - 20) + "px";
    slide_foreground.style.paddingBottom = (footer_height + 10) + "px";
    slide_container.style.height = get_tallest_slide() + "px";
  }

  function whichTransitionEvent() {
      let t, el = document.createElement("fakeelement");
      let transitions = {
          "transition"      : "transitionend",
          "OTransition"     : "oTransitionEnd",
          "MozTransition"   : "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
      }
      for (t in transitions){
          if (el.style[t] !== undefined){
              return transitions[t];
          }
      }
  }

  function detectScrollDirection(e) {
    let scrollings = [];
    let can_scroll = true;
    let next_slide_number = 0;

    let current_time = new Date().getTime();
    // Cross Browser Wheel Delta
    e = e || window.event;
    let value = e.wheelDelta || -e.deltaY || -e.detail;
    let delta = Math.max(-1, Math.min(1, value));
    // Detect Horizontal Scroll
    let horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
    let isScrollingVertically = (Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta)) || (Math.abs(e.deltaX ) < Math.abs(e.deltaY) || !horizontalDetection);
    // Limiting array to 150 to save memory
    if(scrollings.length > 149){
      scrollings.shift();
    }
    // Record Previous Scrollings
    scrollings.push(Math.abs(value));
    // Calculate time difference between the last scroll and the current one
    let timeDiff = current_time - previous_time;
    let transitionTimeDiff = current_time - last_transition;
    previous_time = current_time;
    // If scroll event finished
    if(timeDiff > 300 && transitionTimeDiff > 300){
      // Empty scroll array as event is finished
      scrollings = [];
      if(can_scroll) {
        let averageEnd = getAverage(scrollings, 10);
        let averageMiddle = getAverage(scrollings, 70);
        let isAccelerating = averageEnd >= averageMiddle;
        // Avoid Double Swipes
        if(isAccelerating && isScrollingVertically){
          // If is slowing down, else scrolling up, 1 is up, 0 is down
          if (delta < 0) {
              last_transition = new Date().getTime();
              next_slide_number = toggle_slide_direction(current_slide_number, 1);
          } else {
              last_transition = new Date().getTime();
              next_slide_number = toggle_slide_direction(current_slide_number, 0);
          }
        }
      }
    }
  }

  function getAverage(elements, number){
    let sum = 0;
    //taking `number` elements from the end to make the average, if there are not enought, 1
    let lastElements = elements.slice(Math.max(elements.length - number, 1));
    for(let i = 0; i < lastElements.length; i++){
      sum = sum + lastElements[i];
    }
    return Math.ceil(sum / number);
  }

  function toggle_slide_direction(slide_number, direction) {
    let next_slide = 0;
    let next_slide_number = (direction) ? slide_number + 1 : slide_number - 1;
    if (direction) {
      next_slide = (next_slide_number == slide_list.length) ? 0 : next_slide_number;
    } else {
      next_slide = (next_slide_number >= 0) ? next_slide_number : slide_list.length - 1;
    }
    let slide = document.getElementById("s" + (next_slide + 1));
    zenscroll.to(slide);
    is_clear(next_slide + 1);
    animate_meta(next_slide);
  }

  function removeHash() {
    var scrollV, scrollH, loc = window.location;
    if ("pushState" in history)
      history.pushState("", document.title, loc.pathname + loc.search);
    else {
      // Prevent scrolling by storing the page's current scroll offset
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;

      loc.hash = "";

      // Restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  }

}

export default init;
